export default {
  LIST_FETCHED: 'VALIDATOR_CODE_FETCHED',
  LIST_LOAD: 'VALIDATOR_CODE_LOAD',
  ITEM_DETAIL: 'VALIDATOR_CODE_DETAIL',
  BUTTON_LOAD: 'VALIDATOR_CODE_BUTTON_LOAD',
};
